import { Box, CircularProgress, Grid, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { Params, useParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { IHotspot } from "@virtus-tech-repository/virtus-tech-repository/lib/models/hotspot.model";
import { EDraggableOptions } from "@virtus-tech-repository/virtus-tech-repository/lib/models/media.model";
import { useEffect, useRef, useState } from "react";
import { useGetScenarioOverviewPublishedQuery, useGetScenarioOverviewQuery } from "../../services/scenario.service";
import { useGetMarksQuery, useLazyGetMarksQuery, useUpdateMarksMutation } from "../../services/marks.service";
import {
    VTMarksDataEntryTable,
    VTMarksTableAccordianWrapper,
    VTTextField,
    VTZoomInOut,
} from "@virtus-tech-repository/virtus-tech-repository";
import { VTMarksDataEntryRowObject } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTMarksDataEntryTable";
import {
    MarksDataStructure,
    MarkedHotspot,
    QuestionHotspot,
    ScenesMarks,
} from "@virtus-tech-repository/virtus-tech-repository/lib/models/marks.model";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import DoneOutlineRoundedIcon from "@mui/icons-material/DoneOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import _ from "lodash";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import errorImage from "../../assets/images/undraw_notify_rnwe.svg";

// TODO: robin, tune this logic to be even better for deterimining default hotspot answer weightings
function getDefaultWeightingScore(hotspot: IHotspot): number {
    if (hotspot.actions && hotspot?.type === EDraggableOptions.ANSWER) {
        if (hotspot?.actions.appFeedback?.proceed) {
            return +1;
        }
    }

    return 0;
}

// TODO: robin, tune this logic to be even better for deterimining default hotspot names (non-answer hotspots)
function hotspotTypeEnumToString(hotspotType: EDraggableOptions) {
    return hotspotType.replace(/_/g, " ");
}

interface HotspotMarks {
    // hotspotId: string;
    hotspotName: string;
    marked: boolean;
    correct: boolean;
    weighting: number;
}

type QuestionAnswerHotspots = { timeInSeconds: number; hotspotMarks: HotspotMarks[] };
export type MarksHotspotData = {
    [key: string]: {
        [key: string]: HotspotMarks[] | QuestionAnswerHotspots;
    };
};

interface IEditMarksContainerProps {
    drawWidth: number;
}

export default function EditMarksContainer({ drawWidth }: IEditMarksContainerProps) {
    const theme = useTheme();

    const { scenarioId }: Readonly<Params<string>> = useParams();

    const { currentScenesTimelineHeight, selectedVersion } = useAppSelector((state) => state.currentReducer);


    const { data: scenarioOverviewData } = useGetScenarioOverviewPublishedQuery({
        scenarioId: scenarioId ? scenarioId : "",
        scenarioPublishedId: selectedVersion ? selectedVersion : "",
    });

    useEffect(() => {
        return () => {
        };
    }, []);

    let [
        triggerGetMarks,
        { data: marksData, isLoading: isLoadingMarks, error: marksError, isSuccess: marksIsSuccess },
        lastPromiseInfo,
    ] = useLazyGetMarksQuery();


    const marksGetRequestHasFinished = typeof lastPromiseInfo.lastArg === "string";



    useEffect(() => {
        if (selectedVersion) {

            triggerGetMarks(selectedVersion);
        }
    }, [selectedVersion]);


    const [
        updateMarks,
        {
            isLoading: isUpdatingMarks,
            isSuccess: postingMarksIsSuccess,
            isError: postingMarksIsError,
            isUninitialized: postingMarksIsUninitialized,
        },
    ] = useUpdateMarksMutation();


    const [tableZoom, setTableZoom] = useState<number>(0.7);

    const [marshaledScenesDataAsMarks, setMarshaledScenesDataAsMarks] = useState<MarksDataStructure>();

    const marshaledScenesDataAsMarksSinceLastSaveRef = useRef<MarksDataStructure>();


    // is this needed still?
    const [loading, setLoading] = useState<boolean>(true);
    useEffect(() => {
        window.setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, []);

    const [loadingMessage, setLoadingMessage] = useState<string>("Attempting To Get Marks");

    useEffect(() => {
        if (scenarioOverviewData && marksGetRequestHasFinished && selectedVersion) {
            const marshaledScenesDataAsMarks_ = scenarioOverviewData?.scenes
                .filter((scene: IScene) => scene.hotspots.length > 0)
                .sort((sceneA: IScene, sceneB: IScene) => sceneA.order! - sceneB.order!)
                .map((scene: IScene) => {
                    return {
                        sceneId: scene.id,
                        sceneName: scene.name,
                        sceneHotspots: scene.hotspots.map((hotspot) => {
                            if (hotspot.type === EDraggableOptions.QUESTION) {
                                const questionHotspotObj: QuestionHotspot = {
                                    hotspotId: hotspot.id,
                                    hotspotType: hotspot.type,
                                    hotspotTitle: hotspot.contents.preClickContent.title
                                        ? hotspot.contents.preClickContent.title
                                        : hotspotTypeEnumToString(hotspot.type),
                                    questionTime: hotspot.contents.preClickContent.question?.time!,
                                    answerHotspots: hotspot.groupedHotspots?.map((answerHotspot) => {
                                        return {
                                            hotspotId: answerHotspot.id,
                                            hotspotType: answerHotspot.type,
                                            hotspotTitle:
                                                answerHotspot.contents.preClickContent.title &&
                                                answerHotspot.contents.preClickContent.title.replace(/\s/g, "").length >
                                                    0
                                                    ? answerHotspot.contents.preClickContent.title
                                                    : hotspotTypeEnumToString(answerHotspot.type),
                                            marked: true,
                                            weighting: getDefaultWeightingScore(answerHotspot),
                                        };
                                    }),
                                };
                                return questionHotspotObj;
                            } else {
                                const normalHotspotObj: MarkedHotspot = {
                                    hotspotId: hotspot.id,
                                    hotspotType: hotspot.type,
                                    hotspotTitle:
                                        hotspot.contents.preClickContent.title &&
                                        hotspot.contents.preClickContent.title.replace(/\s/g, "").length > 0
                                            ? hotspot.contents.preClickContent.title
                                            : hotspotTypeEnumToString(hotspot.type),
                                    marked: false,
                                    weighting: 0,
                                };
                                return normalHotspotObj;
                            }
                        }),
                    };
                });

            //
            if (marksIsSuccess) {
                setLoadingMessage("Retrieving Marks For This Scenario");

                // prior marks data for this scenario exists
                const marksDataLocalSyncedWithServer = marshaledScenesDataAsMarks_!.map(
                    (localSceneMarks: ScenesMarks) => {
                        let sceneMarksDataFromServer = marksData!.find((serverSceneMarks: ScenesMarks) => {
                            return localSceneMarks.sceneId === serverSceneMarks.sceneId;
                        });

                        // if (sceneMarksDataFromServer) {
                        // no marks data for this scene exists in server
                        // }

                        return { ...localSceneMarks, ...sceneMarksDataFromServer };
                    },
                );
                marshaledScenesDataAsMarksSinceLastSaveRef.current = marksDataLocalSyncedWithServer;
                setMarshaledScenesDataAsMarks(marksDataLocalSyncedWithServer);
                // @ts-ignore
            } else if (marksError && marksError.originalStatus === 404) {
                // request successfull but returned an error code saying no previous marks exist
                // no prior marks data for this scenario existed

                setLoadingMessage("Auto-Generating Marks For This Scenario");

                marshaledScenesDataAsMarksSinceLastSaveRef.current = marshaledScenesDataAsMarks_;

                setMarshaledScenesDataAsMarks(marshaledScenesDataAsMarks_);
                updateMarks({
                    scenarioId: selectedVersion,
                    data: marshaledScenesDataAsMarks_,
                });
            }
        }
    }, [scenarioOverviewData, isLoadingMarks, marksIsSuccess, selectedVersion]);

    const marksHaveChangedSinceLastSave = !_.isEqual(
        marshaledScenesDataAsMarks,
        marshaledScenesDataAsMarksSinceLastSaveRef.current,
    );

    const [showSaveResult, setShowSaveResult] = useState<boolean>(false);

    // LocaleTimeString
    const [lastSuccessfulSave, setLastSuccessfulSave] = useState<string>();

    useEffect(() => {
        setLastSuccessfulSave(undefined);
        if (postingMarksIsSuccess) {
            setShowSaveResult(true);
            setLastSuccessfulSave(new Date().toLocaleTimeString());

            let tid = window.setTimeout(() => {
                setShowSaveResult(false);
            }, 2000);
        }
    }, [postingMarksIsSuccess]);

    useEffect(() => {
        setLastSuccessfulSave(undefined);
        if (postingMarksIsError) {
            setShowSaveResult(true);

            let tid = window.setTimeout(() => {
                setShowSaveResult(false);
            }, 2000);
        }
    }, [postingMarksIsError]);

    const [sceneSearchValue, setSceneSearchValue] = useState<string>("");

    return (
        <Grid
            container
            item
            xs={12}
            sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Grid
                item
                xs={12}
                sx={{
                    height: "calc(100vh - " + 68 + "px)",
                    paddingBottom: currentScenesTimelineHeight + 45 + "px",
                    overflowY: "scroll",
                    ...((loading || !marksGetRequestHasFinished) && {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }),
                    position: "relative",
                    marginTop: "45px",
                }}
            >
                <Box
                    component="div"
                    sx={{
                        position: "fixed",
                        top: "68px",
                        zIndex: 100,
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "calc(100% - 80px)",
                        background: "#333",
                    }}
                >
                    <Box
                        component="div"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <VTZoomInOut
                            sx={{ marginLeft: "5px" }}
                            zoomVal={tableZoom}
                            onZoomIn={() => {
                                if (tableZoom > 1) return;
                                setTableZoom(tableZoom + 0.05);
                            }}
                            onZoomOut={() => {
                                if (tableZoom < 0.45) return;
                                setTableZoom(tableZoom - 0.05);
                            }}
                        />

                        <VTTextField
                            sx={{ marginLeft: "15px" }}
                            size="small"
                            value={sceneSearchValue}
                            onChange={(textInput) => {
                                setSceneSearchValue(textInput);
                            }}
                            placeholder="search scene"
                            startIcon={<SearchRoundedIcon />}
                        />
                    </Box>
                    <Box
                        component="div"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {isUpdatingMarks && (
                            <CircularProgress
                                size={30}
                                thickness={4}
                                sx={{
                                    marginRight: "5px",
                                    "& .MuiCircularProgress-circle": {
                                        color: theme.palette.primary.light,
                                    },
                                }}
                            />
                        )}
                        {showSaveResult && postingMarksIsSuccess && (
                            <DoneOutlineRoundedIcon sx={{ color: "#00cc66", marginRight: "10px", opacity: "1" }} />
                        )}

                        {showSaveResult && postingMarksIsError && (
                            <ErrorOutlineRoundedIcon sx={{ color: "red", fontSize: "2em", marginRight: "5px" }} />
                        )}

                        {lastSuccessfulSave &&
                            !postingMarksIsError &&
                            !showSaveResult &&
                            !isUpdatingMarks &&
                            postingMarksIsSuccess && (
                                <Typography sx={{ color: "#aaa", marginRight: "10px" }} variant="caption">
                                    {`last save ${lastSuccessfulSave}`}
                                </Typography>
                            )}

                        <Tooltip title={"undo marks changes"}>
                            <IconButton
                                disabled={isUpdatingMarks || !marksHaveChangedSinceLastSave}
                                sx={{ marginRight: "5px", borderRadius: "5px", height: "34px", width: "34px" }}
                                onClick={() => {
                                    setMarshaledScenesDataAsMarks(marshaledScenesDataAsMarksSinceLastSaveRef.current);
                                }}
                            >
                                <HistoryRoundedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={"save marks changes"}>
                            <IconButton
                                disabled={isUpdatingMarks || !marksHaveChangedSinceLastSave}
                                sx={{ marginRight: "5px", borderRadius: "5px", height: "34px", width: "34px" }}
                                onClick={async () => {
                                    try {
                                        await updateMarks({
                                            scenarioId: selectedVersion,
                                            data: marshaledScenesDataAsMarks,
                                        }).unwrap();
                                        marshaledScenesDataAsMarksSinceLastSaveRef.current = marshaledScenesDataAsMarks;
                                    } catch (e) {
                                    }
                                }}
                            >
                                <SaveRoundedIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                {!loading &&
                    marshaledScenesDataAsMarks &&
                    marshaledScenesDataAsMarks
                        .filter((sceneMarks) =>
                            sceneMarks.sceneName.toLowerCase().includes(sceneSearchValue.toLowerCase()),
                        )
                        .map((sceneWithMarks: ScenesMarks, sceneIndex: number) => {
                            let markedHotspotsInTableFormat = sceneWithMarks.sceneHotspots
                                .filter((hotspot) => {
                                    return !("questionTime" in hotspot);
                                })
                                .map((markedHotspot) => {
                                    markedHotspot = markedHotspot as MarkedHotspot;
                                    return {
                                        id: markedHotspot.hotspotId,
                                        hotspotName: markedHotspot.hotspotTitle,
                                        marked: markedHotspot.marked,
                                        correct: markedHotspot.weighting > 0,
                                        weighting: markedHotspot.weighting,
                                    };
                                });

                            let questionHotspots = sceneWithMarks.sceneHotspots.filter((hotspot) => {
                                return "questionTime" in hotspot;
                            });

                            return (
                                <VTMarksTableAccordianWrapper
                                    sx={{ zoom: tableZoom, background: "#444" }}
                                    title={`scene ${sceneIndex + 1}: ` + sceneWithMarks.sceneName}
                                    initiallyExpanded={questionHotspots.length > 0}
                                >
                                    {markedHotspotsInTableFormat.length > 0 && (
                                        <VTMarksDataEntryTable
                                            // onHotspotNameClicked={(hotspotName: string, hotspotId: string) => {
                                            // }}
                                            // rowsToMakeHotspotNameItalicById={idsOfHotspotsWithNoName}
                                            tableData={markedHotspotsInTableFormat}
                                            onDataChanged={function (
                                                newlyChangedData: VTMarksDataEntryRowObject[],
                                            ): void {
                                                const updatedMarksForScenario = marshaledScenesDataAsMarks!.map(
                                                    (sceneMarks: ScenesMarks) => {
                                                        if (sceneMarks.sceneId === sceneWithMarks.sceneId) {
                                                            let updatedHotspotsForScene = sceneMarks.sceneHotspots.map(
                                                                (markedOrQuestionHotspot) => {
                                                                    const foundChangedDataRow = newlyChangedData.find(
                                                                        (marksRowObject) => {
                                                                            return (
                                                                                marksRowObject.id ===
                                                                                markedOrQuestionHotspot.hotspotId
                                                                            );
                                                                        },
                                                                    );
                                                                    if (foundChangedDataRow) {
                                                                        return {
                                                                            ...markedOrQuestionHotspot,
                                                                            marked: foundChangedDataRow.marked,
                                                                            weighting: foundChangedDataRow.weighting,
                                                                        };
                                                                    } else {
                                                                        return markedOrQuestionHotspot;
                                                                    }
                                                                },
                                                            );

                                                            return {
                                                                ...sceneMarks,
                                                                sceneHotspots: updatedHotspotsForScene,
                                                            };
                                                        } else {
                                                            return sceneMarks;
                                                        }
                                                    },
                                                );

                                                setMarshaledScenesDataAsMarks(updatedMarksForScenario);
                                            }}
                                        />
                                    )}

                                    {questionHotspots
                                        .sort((questionHotspotA, questionHotspotB) => {
                                            questionHotspotA = questionHotspotA as QuestionHotspot;
                                            questionHotspotB = questionHotspotB as QuestionHotspot;
                                            return questionHotspotA.questionTime - questionHotspotB.questionTime;
                                        }) // sort questions by times in order of earlier questions first
                                        .map((questionHotspot, questionIndex: number) => {
                                            questionHotspot = questionHotspot as QuestionHotspot;

                                            let answerHotspotsInTableFormat = questionHotspot.answerHotspots?.map(
                                                (markedHotspot) => {
                                                    markedHotspot = markedHotspot as MarkedHotspot;
                                                    return {
                                                        id: markedHotspot.hotspotId,
                                                        hotspotName: markedHotspot.hotspotTitle,
                                                        marked: markedHotspot.marked,
                                                        correct: markedHotspot.weighting > 0,
                                                        weighting: markedHotspot.weighting,
                                                    };
                                                },
                                            );
                                            return (
                                                <VTMarksTableAccordianWrapper
                                                    sx={{ background: "#444", marginTop: "15px" }}
                                                    title={
                                                        questionHotspot.hotspotTitle +
                                                        ` (Stop Point ${questionIndex + 1})`
                                                    }
                                                    questionTimeInMilliseconds={questionHotspot.questionTime * 1000}
                                                >
                                                    <VTMarksDataEntryTable
                                                        tableData={answerHotspotsInTableFormat!}
                                                        onDataChanged={function (
                                                            newlyChangedData: VTMarksDataEntryRowObject[],
                                                        ): void {
                                                            const updatedMarksForScenario =
                                                                marshaledScenesDataAsMarks!.map(
                                                                    (sceneMarks: ScenesMarks) => {
                                                                        if (
                                                                            sceneMarks.sceneId ===
                                                                            sceneWithMarks.sceneId
                                                                        ) {
                                                                            return {
                                                                                ...sceneMarks,
                                                                                sceneHotspots:
                                                                                    sceneMarks.sceneHotspots.map(
                                                                                        (question) => {
                                                                                            if (
                                                                                                question.hotspotId ===
                                                                                                questionHotspot.hotspotId
                                                                                            ) {
                                                                                                return {
                                                                                                    ...question,
                                                                                                    answerHotspots: (
                                                                                                        question as QuestionHotspot
                                                                                                    ).answerHotspots?.map(
                                                                                                        (
                                                                                                            answerHotspot,
                                                                                                        ) => {
                                                                                                            const foundChangedDataRow =
                                                                                                                newlyChangedData.find(
                                                                                                                    (
                                                                                                                        marksRowObject,
                                                                                                                    ) => {
                                                                                                                        return (
                                                                                                                            marksRowObject.id ===
                                                                                                                            answerHotspot.hotspotId
                                                                                                                        );
                                                                                                                    },
                                                                                                                );
                                                                                                            return {
                                                                                                                ...answerHotspot,
                                                                                                                weighting:
                                                                                                                    foundChangedDataRow!
                                                                                                                        .weighting,
                                                                                                                marked: foundChangedDataRow!
                                                                                                                    .marked,
                                                                                                            };
                                                                                                        },
                                                                                                    ),
                                                                                                };
                                                                                            } else {
                                                                                                return question;
                                                                                            }
                                                                                        },
                                                                                    ),
                                                                            };
                                                                        } else {
                                                                            return sceneMarks;
                                                                        }
                                                                    },
                                                                );

                                                            setMarshaledScenesDataAsMarks(updatedMarksForScenario);
                                                        }}
                                                    />
                                                </VTMarksTableAccordianWrapper>
                                            );
                                        })}
                                </VTMarksTableAccordianWrapper>
                            );
                        })}
                {loading && (
                    <>
                        <CircularProgress
                            size={100}
                            thickness={4}
                            sx={{
                                "& .MuiCircularProgress-circle": {
                                    color: theme.palette.primary.light,
                                },
                            }}
                        />
                        <Typography sx={{ marginTop: "20px" }} variant="body2">
                            {loadingMessage ? loadingMessage : ""}
                        </Typography>
                    </>
                )}

                {!loading && !marshaledScenesDataAsMarks && (
                    <>
                        <img src={errorImage} style={{ height: "120px", width: "auto" }} />
                        <Typography sx={{ marginTop: "20px", color: theme.palette.error.main }} variant="h5">
                            Error Obtaining Marks
                        </Typography>
                        <Typography sx={{ color: "#ccc" }} variant="h6">
                            {" "}
                            please try refreshing or reloading the page{" "}
                        </Typography>
                    </>
                )}
            </Grid>
        </Grid>
    );
}
